// extracted by mini-css-extract-plugin
module.exports = {"white":"_36t0V","black":"_217I5","blue":"_1xxfK","darkblue":"_3LzW1","darkgray":"-ik-h","logo":"_356yT","hdLogo":"_3kKYY"};